import React, { createContext, useState, useEffect } from 'react';

// Создаем контекст
export const VersionContext = createContext();

export const VersionProvider = ({ children }) => {
  const [isNewVersionAvailable, setIsNewVersionAvailable] = useState(false);

  useEffect(() => {
    const handleVersionChange = () => {
      setIsNewVersionAvailable(true);
    };

    // Слушаем событие появления новой версии
    window.addEventListener('NEW_VERSION_AVAILABLE', handleVersionChange);

    return () => {
      window.removeEventListener('NEW_VERSION_AVAILABLE', handleVersionChange);
    };
  }, []);

  const resetVersionState = () => {
    setIsNewVersionAvailable(false);
  };

  return (
    <VersionContext.Provider value={{ isNewVersionAvailable, resetVersionState }}>
      {children}
    </VersionContext.Provider>
  );
};
